import type { SurfaceProps } from './types';
import { surfaceFilled } from './types';

/** Free-text fallback surface (reflective homeworks, links). */
export function FreeText({ spec, value, disabled, onChange }: SurfaceProps) {
  const text = String(value?.text ?? '');
  return (
    <div className="surf surf-free">
      <textarea
        className="surf-ta"
        value={text}
        disabled={disabled}
        placeholder={
          spec.config?.placeholder ??
          'Вставь ссылку на документ или сам текст решения — он сохранится и попадёт в твоё портфолио.'
        }
        onChange={(e) => {
          const next = { text: e.target.value };
          onChange(next, surfaceFilled(spec, next));
        }}
        data-testid="surf-freetext"
      />
    </div>
  );
}
